import i18next from "i18next";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getFlightsMiniInfo } from "../../../info/allFlights";
import { List, Title, Wrapper } from "./style";

export const FlightsListComponent = () => {
  const { t, language } = i18next;
  const [flights, setFlights] = useState([]);

  useEffect(() => {
    const getAllFlights = async () => {
      const flights = await getFlightsMiniInfo(0, false);

      setFlights(flights);
    };

    getAllFlights();
  }, []);

  return (
    <Wrapper>
      <Title>{t("routes")}</Title>

      <List>
        {flights.map(item => {
          const destination = {
            pathname: `${item.key}`,
            state: { ...item.name },
          };
          return (
            <Link key={item.key} to={destination}>
              {item.name[language]}
            </Link>
          );
        })}
      </List>
    </Wrapper>
  );
};
